import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf53cdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header warning" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "WARNING!!!")
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Print or frame"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty"),
    /*#__PURE__*/_createElementVNode("th", null, "H (cm)"),
    /*#__PURE__*/_createElementVNode("th", null, "W (cm)"),
    /*#__PURE__*/_createElementVNode("th", null, "H (in)"),
    /*#__PURE__*/_createElementVNode("th", null, "W (in)")
  ])
], -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "TOTAL", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "filler"
}, " ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_12 = {
  key: 1,
  style: {"width":"15.5vw"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ASF branding"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty")
  ])
], -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "TOTAL", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "Have you checked the order to ensure: address, number of prints, COAS, Stickers, Inserts, size of prints, framed or unframed parameters are correct?", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  disabled: "",
  selected: "",
  class: "option-placeholder"
}, "Choose a qc user", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    (_ctx.summary.printGroup.total > 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.printGroup.items, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: (item as any).name,
                                value: (item as any).name
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(item.style)
                                  }, _toDisplayString(item.name), 3)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
                                _createElementVNode("td", null, _toDisplayString(item.heightCm.toFixed(2)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.widthCm.toFixed(2)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.heightIn.toFixed(2)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.widthIn.toFixed(2)), 1)
                              ], 8, _hoisted_8))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_9,
                              _createElementVNode("td", null, _toDisplayString(_ctx.summary.printGroup.total), 1),
                              _hoisted_10
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    (_ctx.summary.brandingGroup.total > 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.brandingGroup.items, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: (item as any).name,
                                value: (item as any).name
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(item.style)
                                  }, _toDisplayString(item.name), 3)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.quantity), 1)
                              ], 8, _hoisted_14))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_15,
                              _createElementVNode("td", null, _toDisplayString(_ctx.summary.brandingGroup.total), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedQcUserId) = $event)),
                    class: "form-select"
                  }, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qcUsers, (qcUser) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: (qcUser as any).Id,
                        value: (qcUser as any).Id
                      }, _toDisplayString((qcUser as any).Name), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedQcUserId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "btn btn-success margin-right",
                    disabled: !_ctx.isQcUserSelected,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                  }, " Yes ", 8, _hoisted_20),
                  _createElementVNode("button", {
                    class: "btn btn-danger",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                  }, " Cancel ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}